import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { PersistenceService } from './persistence';
import { FileUpload } from '@shared/models';

@UntilDestroy()
@Injectable()
export class ClientSupportService {
  constructor(private persistenceService: PersistenceService) {}

  getUserManualDetails(clientId: string): Observable<FileUpload> {
    return this.persistenceService.getUserManualDetails(clientId);
  }
}
